import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import {
  getCountdownDays,
  getCountdownHours,
  getCountdownMinutes,
  getCountdownSeconds,
} from '../../selectors';
import Segment from './Segment';
import theme from '../../styles/theme';

const Countdown = ({
  classes, className, days, hours, minutes, seconds,
}) => {
  const separator = (
    <span className={classes.separator} />
  );
  return (
    <div className={cn(className, classes.countdown)}>
      <Segment caption="Days" value={days} animated={false} />
      {separator}
      <Segment caption="Hours" value={hours} animated={false} />
      {separator}
      <Segment caption="Minutes" value={minutes} animated={false} />
      {separator}
      <Segment caption="Seconds" value={seconds} animated={false} />
    </div>
  );
};

Countdown.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  days: PropTypes.number.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  seconds: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  itemIndex: PropTypes.number,
};

Countdown.defaultProps = {
  className: undefined,
  itemIndex: undefined,
};

const mapStateToProps = (state, { sliceId, itemIndex }) => ({
  days: getCountdownDays(state, sliceId, itemIndex),
  hours: getCountdownHours(state, sliceId, itemIndex),
  minutes: getCountdownMinutes(state, sliceId, itemIndex),
  seconds: getCountdownSeconds(state, sliceId, itemIndex),
});

export default compose(
  connect(mapStateToProps),

  injectSheet({
    countdown: {
      display: 'flex',
      alignItems: 'center',
      perspective: '10em',
      transformStyle: 'preserve-3d',
      position: 'relative',
    },
    separator: {
      flex: '0 0 auto',
      height: '0.3em',
      margin: '0 12px 0.3em',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        margin: '0 20px 0.3em',
      },
      '&>*': {
        position: 'absolute',
        display: 'block',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
      },
      '&>svg': {
        stroke: 'currentColor',
        strokeWidth: 2,
        fill: 'none',
      },
      '&>span': {
        overflow: 'hidden',
        textIndent: '-1em',
      },
    },
  }),
)(Countdown);
